import { Box, Flex, Text } from '@mantine/core'
import { useTranslations } from 'next-intl'

import InfoCircle from '@/assets/icons/info-circle.svg'

import styles from './index.module.css'

export enum TradingTipsType {
  UnTradable = 'unTradable',
  Restricted = 'restricted',
}

interface TradingTipsProps {
  symbol: string
  type: TradingTipsType
  openCoinListModal?: () => void
}

const TIPS_MESSAGE_KEY_MAP: Record<TradingTipsType, string> = {
  [TradingTipsType.UnTradable]: 'unTradableTips',
  [TradingTipsType.Restricted]: 'notTradableTips',
}

export default function TradingTips({ symbol, type, openCoinListModal }: TradingTipsProps) {
  const t = useTranslations('tradeWidget')
  const messageKey = TIPS_MESSAGE_KEY_MAP[type]

  return (
    <Flex className={styles.tradingTips}>
      <InfoCircle height={20} fill={'var(--common-white)'} />
      <Box flex={1} ml={8}>
        <Text variant={'subtitle'} c={'var(--content-secondary)'}>
          {t(messageKey, { symbol })}
        </Text>
        {openCoinListModal && (
          <Text
            variant={'subtitle'}
            c={'var(--content-active)'}
            style={{ cursor: 'pointer' }}
            onClick={openCoinListModal}
          >
            {t('exploreOtherCoins')}
          </Text>
        )}
      </Box>
    </Flex>
  )
}
